import api from 'Cloud/Application/api';
import type { Method } from 'lib/axios';
import { APICallV4 } from 'reactApp/api/APICall';
import { apiMigrateFileV2ToV4 } from 'reactApp/appHelpers/featuresHelpers';
import { promisifyDeferredCall } from 'reactApp/utils/helpers';

const method = 'file/info';

class FileInfoAPIV4Call extends APICallV4 {
    _method = method;
    _type: Method = 'get';
}

export const getFileInfoApiCall = (params: Record<string, any>): Promise<unknown> => {
    if (apiMigrateFileV2ToV4.info) {
        return new FileInfoAPIV4Call().makeRequest({ ...params, path: params.home });
    }

    return promisifyDeferredCall(api.file, params);
};
